<jb-hero-skeleton></jb-hero-skeleton>
<jb-navigation-block-skeleton></jb-navigation-block-skeleton>
<div class="bg-white min-h-10"></div>
